import React from 'react';
import styles from './InfoCallout.module.css';

interface InfoCalloutProps {
  variant: 'info' | 'tip' | 'warning';
  children: React.ReactNode;
}

const variantLabels: Record<InfoCalloutProps['variant'], string> = {
  info: 'Note',
  tip: 'Tip',
  warning: 'Warning',
};

export const InfoCallout: React.FC<InfoCalloutProps> = ({ variant, children }) => {
  return (
    <div className={`${styles.callout} ${styles[variant]}`}>
      <div className={styles.label}>{variantLabels[variant]}</div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
